// extracted by mini-css-extract-plugin
export default {"OrderCreatedModal":"OrderCreatedModal__OrderCreatedModal___rEubl","orderCreatedModalIcon":"OrderCreatedModal__orderCreatedModalIcon___vHrt7"};